import React from "react";
import { Button } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const DefaultButtonDisabled = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Contained Disabled button"}
        value={"<Button disabled>Disabled</Button>"}
      >
        <Button disabled>Disabled</Button>
      </PreviewAndEditor>
    </>
  );
};

export default DefaultButtonDisabled;
